import { unstable_batchedUpdates } from 'react-dom'

/**
 * Alias for `unstable_batchedUpdates`
 * @see unstable_batchedUpdates
 */
export const bup = unstable_batchedUpdates
